<template>
  <div
    v-if="item && item.title"
    class="w-full md:min-h-1/3 block md:grid md:grid-cols-10 pt-4 md:pt-4"
  >
    <div class="col-start-1 col-end-2 mb-4 flex flex-col justify-between">
      <div><span v-if="index == 0">NEWS</span></div>
      <div>{{ item.date }}</div>
    </div>
    <div
      ref="scroll"
      class="col-start-2 col-end-13 mb-4 whitespace-nowrap relative z-10 h-24 lg:cursor-none"
      @click="active = !active"
      @mousemove="changeHover()"
      @mouseleave="changeCursor('')"
    >
      <div class="title">
        <div class="title-inner">
          <span>{{ item.title }}</span>
          <span>{{ item.title }}</span>
          <span>{{ item.title }}</span>
          <span>{{ item.title }}</span>
        </div>
      </div>
      <!-- <h1 class="text-8xl uppercase pr-8"></h1> -->
    </div>
    <div
      class="col-start-2 col-end-7 space-y-4"
      v-html="item.text"
      v-if="active"
      @mousemove="changeCursor('')"
      @mouseleave="changeCursor('')"
    ></div>
    <div class="col-start-8 col-end-13 uppercase" v-if="active">
      <a
        :href="item.link"
        target="_blank"
        @mousemove="changeCursor('OPEN')"
        @mouseleave="changeCursor('')"
        >{{ item.link }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    index: Number,
  },
  data() {
    return {
      active: false,
      offset: 0,
    };
  },
  mounted() {
    this.$refs.scroll.addEventListener("wheel", this.scrollTitle);
  },
  methods: {
    scrollTitle(event) {
      let maxWidth = this.item.title.length * 50;
      if (this.offset >= 0 && this.offset <= maxWidth) {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
          this.offset = this.offset + event.deltaX;
        }
      }
      if (this.offset < 0) {
        this.offset = 0;
      }
      if (this.offset > maxWidth) {
        this.offset = maxWidth;
      }
    },
    changeCursor(name) {
      this.$root.$emit("changeCursor", name);
    },
    changeHover() {
      if (this.active) {
        this.$root.$emit("changeCursor", "MINIMIZE");
      } else {
        this.$root.$emit("changeCursor", "MAXIMIZE");
      }
    },
  },
};
</script>
